
import React, { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Clock, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export const PromoCountdownBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0
  });
  const navigate = useNavigate();

  useEffect(() => {
    // Check if banner was dismissed today
    const dismissed = localStorage.getItem('promo-banner-dismissed');
    const today = new Date().toDateString();
    
    if (dismissed === today) {
      setIsVisible(false);
      return;
    }

    const calculateTimeLeft = () => {
      const deadline = new Date('2025-06-30T23:59:59');
      const now = new Date();
      const difference = deadline.getTime() - now.getTime();

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

        setTimeLeft({ days, hours, minutes });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0 });
        setIsVisible(false);
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  const handleDismiss = () => {
    const today = new Date().toDateString();
    localStorage.setItem('promo-banner-dismissed', today);
    setIsVisible(false);
  };

  const handleUpgrade = () => {
    navigate('/subscription/plans');
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        className="sticky top-0 z-40 bg-gradient-to-r from-red-500 via-purple-600 to-blue-600 text-white shadow-lg"
      >
        <div className="container mx-auto px-4 py-2">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 flex-1">
              <Badge className="bg-white text-red-600 font-bold px-2 py-1 animate-pulse">
                🔥 50% OFF
              </Badge>
              
              <div className="hidden sm:flex items-center gap-2">
                <Clock className="h-4 w-4" />
                <span className="text-sm font-medium">
                  {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m left
                </span>
              </div>
              
              <span className="text-sm font-medium">
                Pro Plan - Price doubles July 1st!
              </span>
            </div>

            <div className="flex items-center gap-2">
              <Button
                variant="secondary"
                size="sm"
                onClick={handleUpgrade}
                className="bg-white text-purple-600 hover:bg-gray-100 font-medium px-4"
              >
                Upgrade Now
              </Button>
              
              <Button
                variant="ghost"
                size="icon"
                onClick={handleDismiss}
                className="text-white hover:bg-white/20 h-8 w-8"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
